export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    get({}, { levelOneFilter, levelTwoFilter }) {
      let url = `${process.env.VUE_APP_API_BASE_URI}naics/`;

      if (levelOneFilter) {
        url += `${levelOneFilter}/`;
        if (levelTwoFilter) {
          url += levelTwoFilter;
        }
      }

      return axios.get(url).then((res) => res.data);
    },
  },
};
